var _path, _g, _rect, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPrizes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 94,
    viewBox: "0 0 74 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8989 77.754V81.17C12.0249 81.184 12.6549 81.31 13.5929 81.31C15.6649 81.31 16.2529 80.498 16.2529 79.49C16.2529 78.552 15.7489 77.67 13.4949 77.67C12.5989 77.67 12.0529 77.712 11.8989 77.754ZM10.2749 86V77.306C10.2749 76.704 10.6109 76.494 11.0449 76.396C11.3389 76.34 12.0809 76.256 13.5369 76.256C16.5189 76.256 17.9609 77.53 17.9609 79.49C17.9609 81.338 16.7989 82.724 13.7049 82.724C12.9209 82.724 12.0249 82.584 11.8989 82.584V86H10.2749ZM19.3345 86V81.478C19.3345 79.756 20.4545 78.776 22.3165 78.776C23.4925 78.776 24.3045 79.098 24.3045 79.77C24.3045 80.092 24.0665 80.442 23.9545 80.512C23.6325 80.358 23.1705 80.204 22.5685 80.204C21.4765 80.204 20.9305 80.778 20.9305 81.94V86H19.3345ZM30.692 84.362L31.28 85.482C30.972 85.678 29.992 86.196 28.48 86.196C26.408 86.196 24.728 84.894 24.728 82.542C24.728 80.302 26.352 78.776 28.536 78.776C30.482 78.776 31.546 79.84 31.546 81.1C31.546 82.388 30.692 83.284 27.486 83.284C27.108 83.284 26.814 83.27 26.436 83.256C26.59 84.208 27.346 84.852 28.788 84.852C29.754 84.852 30.454 84.488 30.692 84.362ZM26.366 82.164C26.8 82.178 27.178 82.178 27.57 82.178C29.642 82.178 29.992 81.618 29.992 81.072C29.992 80.358 29.348 80.008 28.508 80.008C27.136 80.008 26.408 81.072 26.366 82.164ZM26.856 78.076L26.282 77.404L27.598 76.354C27.864 76.144 28.158 75.906 28.494 75.906C28.83 75.906 29.138 76.13 29.404 76.34L30.706 77.404L30.132 78.076L28.494 77.068L26.856 78.076ZM32.7329 86V81.478C32.7329 79.7 34.0769 78.776 35.8129 78.776C36.9749 78.776 37.9129 79.21 38.4589 80.05C39.0049 79.21 39.9289 78.776 41.0629 78.776C42.7849 78.776 44.1149 79.672 44.1149 81.464V86H42.5189V82.01C42.5189 80.722 41.9029 80.218 40.9089 80.218C39.9569 80.218 39.2289 80.792 39.2289 82.178V86H37.6329V82.178C37.6329 80.792 36.9049 80.218 35.9529 80.218C34.9869 80.218 34.3289 80.736 34.3289 82.024V86H32.7329ZM45.8049 86V79.714C45.8049 79.196 46.1129 78.972 46.6589 78.972C46.9949 78.972 47.3029 79.084 47.4009 79.126V86H45.8049ZM46.6029 75.822C47.1489 75.822 47.5689 76.242 47.5689 76.788C47.5689 77.334 47.1489 77.754 46.6029 77.754C46.0569 77.754 45.6369 77.334 45.6369 76.788C45.6369 76.242 46.0569 75.822 46.6029 75.822ZM52.6818 78.776C54.8658 78.776 56.5318 80.358 56.5318 82.486C56.5318 84.572 54.8658 86.196 52.6818 86.196C50.4978 86.196 48.8318 84.572 48.8318 82.486C48.8318 80.358 50.4978 78.776 52.6818 78.776ZM52.6818 84.782C53.9698 84.782 54.8658 83.774 54.8658 82.486C54.8658 81.17 53.9698 80.176 52.6818 80.176C51.3938 80.176 50.4978 81.17 50.4978 82.486C50.4978 83.774 51.3938 84.782 52.6818 84.782ZM57.4555 85.328L58.0575 84.25C58.3095 84.432 59.4435 84.95 60.9135 84.95C61.8795 84.95 62.5655 84.726 62.5655 84.11C62.5655 83.592 62.2295 83.34 61.2215 83.228L60.1295 83.102C58.6315 82.948 57.5815 82.36 57.5815 80.988C57.5815 79.798 58.4635 78.776 60.7735 78.776C62.7195 78.776 63.8395 79.252 63.8395 79.938C63.8395 80.358 63.4615 80.652 63.3495 80.694C63.1955 80.54 62.3415 79.98 60.7875 79.98C59.7095 79.98 59.1635 80.26 59.1635 80.834C59.1635 81.324 59.5835 81.548 60.3535 81.646L61.7815 81.828C63.3355 82.038 64.2315 82.64 64.2315 83.886C64.2315 85.286 63.0835 86.196 60.9975 86.196C58.9955 86.196 57.6655 85.51 57.4555 85.328Z",
    fill: "#FF2D55"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10007_11006)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 36,
    r: 28,
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.1252,
    y: 27.25,
    width: 27.75,
    height: 7.125,
    rx: 1.5,
    stroke: "#FF2D55",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1 27.0754L43.7571 23.0774C44.2305 22.7931 44.8316 22.954 45.0996 23.4369L47.313 27.4247",
    stroke: "#FF2D55",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9004 27.0754L30.2434 23.0774C29.7699 22.7931 29.1688 22.954 28.9008 23.4369L26.6875 27.4247",
    stroke: "#FF2D55",
    strokeWidth: 1.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.25 34.375H40.75V42.9044C40.75 43.2847 40.3423 43.5258 40.009 43.3425L37.4819 41.9526C37.1818 41.7876 36.8182 41.7876 36.5181 41.9526L33.991 43.3425C33.6577 43.5258 33.25 43.2847 33.25 42.9044V34.375Z",
    stroke: "#FF2D55",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0002 34.375H49.0002V48.875C49.0002 49.9796 48.1048 50.875 47.0002 50.875H27.0002C25.8956 50.875 25.0002 49.9796 25.0002 48.875V34.375Z",
    stroke: "#FF2D55",
    strokeWidth: 1.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10007_11006",
    x: 0,
    y: 0,
    width: 74,
    height: 74,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10007_11006"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10007_11006",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrizes);
export default __webpack_public_path__ + "static/media/icon-prizes.d7246e3312d68e374e0c07dae859ebc3.svg";
export { ForwardRef as ReactComponent };